import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-important-link',
  templateUrl: './important-link.component.html',
  styleUrls: ['./important-link.component.scss']
})
export class ImportantLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
